import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { setAuthToken } from '@/shared/api';

interface AccountTokenState {
  readonly token: string | null;
  readonly setToken: (token: string | null) => void;
}

/**
 * The **token only**. Who the patient is lives in TanStack Query, because it is
 * server state — duplicating it here would give the app two answers to "am I
 * signed in?" (CLAUDE.md §7.3).
 *
 * Stored under its own key, separate from `clinic.staff.token`. A shared key
 * would mean signing in at the front desk silently replaced whichever session
 * the browser already held, and the two guards are separate by design (§3.3).
 *
 * The store also feeds the http client's Authorization header, so setting it
 * here and rehydrating on boot keeps the two in step.
 */
export const useAccountTokenStore = create<AccountTokenState>()(
  persist(
    (set) => ({
      token: null,
      setToken: (token: string | null): void => {
        setAuthToken(token, 'account');
        set({ token });
      },
    }),
    {
      name: 'clinic.account.token',
      onRehydrateStorage:
        () =>
        (state): void => {
          setAuthToken(state?.token ?? null, 'account');
        },
    },
  ),
);
